import { NameText } from './components/table/NameText.tsx'
import { Popover } from './components/ui/popover'
import { Tooltip } from './components/ui/tooltip'
import cx from 'classnames'
import React from 'react'
import { AmazonLink } from './components/amazon_link'
import { KeywordMatchTypeBadge } from './components/badge/KeywordMatchTypeBadge'
import { MatchTypeSmall } from './components/badge/MatchTypeSmall'
import { resolveStateMessage, StateIndicator } from './components/badge/SmallBadge'
import { resolveValueAndMessage, StateBadge } from './components/badge/StateBadge'
import { TargetingTypeBadge } from './components/badge/TargetingTypeBadge'
import { TargetingTypeSmall } from './components/badge/TargetingTypeSmall'
import { TargetedProducts } from './components/products/TargetedProducts'
import { TotalPromotionsNames } from './components/products/TotalPromotionsNames'
import { SmartBidSettingBadge } from './components/SmartBidSettingsBadge'
import { TargetACOS } from './components/TargetACOS'
import { PreservingLink } from './components/ui/PreservingLink'
import { RelativeTimestamp } from './components/ui/RelativeTimestamp'
import { resolveInitialSearchQuery } from './reducers/user'
import { cents, money, number, percentage } from './util/formatters'

import { SmartBidToggle } from './components/campaigns/SmartBidToggle'
import { AcosCell } from './components/table/AcosCell'
import { AovCell } from './components/table/AovCell'
import { CacCell } from './components/table/CacCell'
import { CpcCell } from './components/table/CpcCell'
import { CtrCell } from './components/table/CtrCell'
import { CvrCell } from './components/table/CvrCell'
import { RenderAdGroupName } from './components/table/RenderAdGroupName.tsx'
import { AdGroupBreadcrumbsComponent } from './components/table/AdGroupBreadcrumbs.tsx'
import { RenderCampaignName } from './components/table/RenderCampaignName.tsx'
import { RoasCell } from './components/table/RoasCell'
import { RpcCell } from './components/table/RpcCell'
import {
    AcosHeader,
    AovHeader,
    CacHeader,
    CpcHeader,
    CtrHeader,
    CvrHeader,
    RoasHeader,
    RpcHeader,
    TargetCpcHeader,
    TosImpShareHeader,
} from './components/table/TooltipHeader'
import { UpdateReportAdTypes } from './util/contstants'
import { parseExpression } from './util/parse_expression'
import { MaxWidthNameColumn } from './util/table.ts'

// Convert a timestamp in seconds or milliseconds to
// a millisecond timestamp
const toMillisecondTimestmap = (v) => {
    if (v < 10000000000) {
        return v * 1000
    }

    return v
}

export class KeywordAndTargetBreadcrumbs extends React.PureComponent {
    render() {
        const searchQuery = resolveInitialSearchQuery()
        const ad_group = this.props.ad_group
        const campaign = this.props.campaign
        const campaign_id = this.props.campaign_id
        const ad_group_id = this.props.ad_group_id
        const campaign_name = this.props.campaign_name
        const ad_group_name = this.props.ad_group_name
        const className = this.props.className
        const stateMessage = this.props.stateMessage
        const adGroupStatus = this.props.ad_group_status
        const campaignStatus = this.props.campaign_status
        const fill = this.props.fill
        const screenshotMode = this.props.screenshotMode

        const campaignId = campaign_id ?? campaign?.campaign_id
        const adGroupId = ad_group_id ?? ad_group?.ad_group_id
        const campaignName = campaign_name ?? campaign?.name
        const adGroupName = ad_group_name ?? ad_group?.name

        let toAdGroup = `/ad-groups/${adGroupId}`
        if (searchQuery) {
            toAdGroup = toAdGroup + `?${searchQuery}`
        }

        let toCampaign = `/campaigns/${campaignId}`
        if (searchQuery) {
            toCampaign = toCampaign + `?${searchQuery}`
        }

        return (
            <div className={cx(className, fill && 'min-w-0 w-full', { blur: screenshotMode })}>
                {stateMessage && <div>{stateMessage}</div>}
                {campaignId && (
                    <div
                        className={cx('flex min-w-0', fill && 'w-full')}
                        style={{
                            maxWidth: fill ? undefined : MaxWidthNameColumn,
                            lineHeight: '21px',
                        }}
                    >
                        <NameText
                            screenshotMode={screenshotMode}
                            className="relative min-w-0 w-full"
                        >
                            <span className="pl-2.5">Campaign:&nbsp;</span>
                            <PreservingLink
                                to={toCampaign}
                                style={{ maxWidth: fill ? undefined : MaxWidthNameColumn }}
                            >
                                <StateIndicator value={campaignStatus} top={6} left={0} />
                                {campaignName}
                            </PreservingLink>
                        </NameText>
                    </div>
                )}
                {!campaignId && <div>-</div>}
                {adGroupId && (
                    <div
                        className={cx('flex min-w-0', fill && 'w-full')}
                        style={{
                            maxWidth: fill ? undefined : MaxWidthNameColumn,
                            lineHeight: '21px',
                        }}
                    >
                        <NameText
                            screenshotMode={screenshotMode}
                            className="relative min-w-0 w-full"
                        >
                            <span className="pl-2.5">Ad Group:&nbsp;</span>
                            <PreservingLink
                                to={toAdGroup}
                                style={{ maxWidth: fill ? undefined : MaxWidthNameColumn }}
                            >
                                <StateIndicator value={adGroupStatus} top={6} left={0} />
                                {adGroupName}
                            </PreservingLink>
                        </NameText>
                    </div>
                )}
                {!adGroupId && <div>-</div>}
            </div>
        )
    }
}

export { AdGroupBreadcrumbsComponent }

export class RenderKeywordOrTargetName extends React.PureComponent {
    render() {
        const entity_type = this.props.data?.entity_type
        switch (entity_type) {
            case 'keyword':
                return <RenderKeywordName {...this.props} />
            case 'target':
                return <RenderTargetName {...this.props} />
        }

        const matchType = this.props.data?.target_details?.matchType ?? this.props.data?.match_type
        switch (matchType) {
            case 'EXACT' | 'PHRASE' | 'BROAD':
                return <RenderKeywordName {...this.props} />
            default:
                return <RenderTargetName {...this.props} />
        }
    }
}

export class RenderKeywordName extends React.PureComponent {
    render() {
        const data = this.props.data
        const screenshotMode = this.props.screenshotMode || false
        const link = this.props.link || false
        const smartBidSettings = this.props.smartBidSettings
        const mutateItems = this.props.mutateItems
        const fill = this.props.fill || false

        const keywordText =
            data.keyword_text ?? data.target_details?.keyword ?? data.target_details_keyword
        const id = data.keyword_id ?? data.target_id
        const matchType = data.match_type ?? data.target_details?.matchType

        return (
            <div className={cx('flex min-w-0 items-center', fill && 'w-full')}>
                {smartBidSettings && (
                    <SmartBidSettingBadge
                        className="mr-3"
                        parent_id={data.keyword_id}
                        parent_type={UpdateReportAdTypes.Keywords}
                        active={
                            data?.smart_bid_setting?.length ? data.smart_bid_setting[0].id : false
                        }
                        mutateItems={mutateItems}
                    />
                )}
                <div className="flex min-w-0 flex-1 items-center">
                    <MatchTypeSmall
                        className="mr-2"
                        matchType={matchType}
                        parent_ad_group_status={data.parent_ad_group_status}
                        parent_campaign_status={data.parent_campaign_status}
                        state={data.state}
                    />
                    <div
                        style={{ maxWidth: fill ? undefined : 200 }}
                        className={cx('min-w-0', fill && 'flex-1', { blur: screenshotMode })}
                    >
                        {link ? (
                            <PreservingLink
                                className={cx(fill && 'block min-w-0 w-full')}
                                to={'/keywords/' + id}
                            >
                                <NameText
                                    screenshotMode={screenshotMode}
                                    className={cx(fill && 'min-w-0 w-full')}
                                >
                                    {keywordText}
                                </NameText>
                            </PreservingLink>
                        ) : (
                            <NameText
                                screenshotMode={screenshotMode}
                                className={cx(fill && 'min-w-0 w-full')}
                            >
                                {keywordText}
                            </NameText>
                        )}
                    </div>
                </div>
            </div>
        )
    }
}

export class RenderTargetName extends React.PureComponent {
    render() {
        const data = this.props.data
        const screenshotMode = this.props.screenshotMode || false
        const link = this.props.link || false
        const smartBidSettings = this.props.smartBidSettings
        const mutateItems = this.props.mutateItems
        const fill = this.props.fill || false

        return (
            <div
                className={cx('flex min-w-0 items-center', fill && 'w-full')}
                style={{ lineHeight: '21px' }}
            >
                {smartBidSettings && (
                    <SmartBidSettingBadge
                        className="mr-3"
                        parent_id={data.target_id}
                        parent_type={UpdateReportAdTypes.Targets}
                        active={
                            data?.smart_bid_setting?.length ? data.smart_bid_setting[0].id : false
                        }
                        mutateItems={mutateItems}
                    />
                )}
                <div className="flex min-w-0 flex-1 items-center">
                    <TargetingTypeSmall
                        className="mr-2"
                        targeting_type={data.expression_type}
                        parent_ad_group_status={data.parent_ad_group_status}
                        parent_campaign_status={data.parent_campaign_status}
                        state={data.state}
                    />
                    <div
                        style={{ maxWidth: fill ? undefined : 200 }}
                        className={cx('min-w-0', fill && 'flex-1', { blur: screenshotMode })}
                    >
                        {link ? (
                            <PreservingLink
                                className={cx(fill && 'block min-w-0 w-full')}
                                to={'/targets/' + data.target_id}
                            >
                                <NameText
                                    screenshotMode={screenshotMode}
                                    className={cx(fill && 'min-w-0 w-full')}
                                >
                                    {parseExpression(data)}
                                </NameText>
                            </PreservingLink>
                        ) : (
                            <NameText
                                screenshotMode={screenshotMode}
                                className={cx(fill && 'min-w-0 w-full')}
                            >
                                {parseExpression(data)}
                            </NameText>
                        )}
                    </div>
                </div>
            </div>
        )
    }
}

export class RenderASIN extends React.PureComponent {
    render() {
        const {
            asin,
            state,
            adGroup,
            ad_group_id,
            ad_group_name,
            campaign,
            campaign_id,
            campaign_name,
            screenshotMode = false,
            popover = true,
            parent_ad_group_status,
            parent_campaign_status,
            creative_products_product_id = undefined,
            creative_products_product_id_type = undefined,
        } = this.props

        const raw = resolveValueAndMessage(state, parent_ad_group_status, parent_campaign_status)
        const { value, message: stateMessage } = resolveStateMessage(raw)

        const displayAsin = asin
            ? asin
            : creative_products_product_id
              ? creative_products_product_id
              : undefined

        return (
            <div className="d-flex flex-column" style={{ lineHeight: '21px' }}>
                {popover && (
                    <div
                        style={{ maxWidth: MaxWidthNameColumn }}
                        className={cx({
                            blur: screenshotMode,
                        })}
                    >
                        <Popover
                            content={
                                <KeywordAndTargetBreadcrumbs
                                    screenshotMode={screenshotMode}
                                    className="p-2"
                                    ad_group={adGroup}
                                    ad_group_id={ad_group_id}
                                    ad_group_name={ad_group_name}
                                    campaign={campaign}
                                    campaign_id={campaign_id}
                                    campaign_name={campaign_name}
                                    stateMessage={stateMessage}
                                    ad_group_status={parent_ad_group_status}
                                    campaign_status={parent_campaign_status}
                                />
                            }
                            interactionKind="hover"
                        >
                            <div className="relative">
                                {state && <StateIndicator value={value} top={6} />}
                                <AmazonLink
                                    className="pl-2"
                                    asin={displayAsin}
                                    screenshotMode={screenshotMode}
                                />
                            </div>
                        </Popover>
                    </div>
                )}
                {!popover && <AmazonLink asin={displayAsin} screenshotMode={screenshotMode} />}
            </div>
        )
    }
}

export const Columns = {
    PortfolioName: {
        key: 'name',
        cell: (portfolio, { screenshotMode }) => (
            <div>
                <p
                    className={cx('mb-1', {
                        blur: screenshotMode,
                    })}
                >
                    {portfolio.name}
                </p>
            </div>
        ),
        width: 400,
    },
    CampaignName: {
        width: 400,
        key: 'name',
        title: 'Campaign',
        cell: (campaign, { screenshotMode, mutateItems, ...extra }) => (
            <RenderCampaignName
                {...{
                    data: campaign,
                    screenshotMode,
                    mutateItems,
                    ...extra,
                }}
            />
        ),
    },
    AdGroupName: {
        width: 250,
        key: 'name',
        title: 'Ad Group',
        cell: (adGroup, { screenshotMode, mutateItems, props, ...extra }) => (
            <RenderAdGroupName
                {...{
                    data: adGroup,
                    screenshotMode,
                    mutateItems,
                    showSmartBidSettings: props?.showSmartBidSettings,
                    ...extra,
                }}
            />
        ),
    },
    State: { key: 'state', title: 'State', cell: (state) => <StateBadge {...state} /> },
    ASIN: {
        key: 'asin',
        total_key: 'name',
        title: 'ASIN',
        cell: (
            {
                asin,
                state,
                adGroup,
                campaign,
                campaign_id,
                campaign_name,
                ad_group_id,
                ad_group_name,
                parent_ad_group_status,
                parent_campaign_status,
                creative_products_product_id,
                creative_products_product_id_type,
            },
            { screenshotMode, props },
        ) => {
            return (
                <RenderASIN
                    {...{
                        asin,
                        state,
                        adGroup,
                        ad_group_id,
                        ad_group_name,
                        campaign_id,
                        campaign_name,
                        campaign,
                        screenshotMode,
                        parent_ad_group_status,
                        parent_campaign_status,
                        popover: props?.popover,
                        creative_products_product_id,
                        creative_products_product_id_type,
                    }}
                />
            )
        },
    },
    AdGroupBreadcrumbs: {
        key: 'campaign_name',
        title: 'Campaign',
        cell: (data, extra) => (
            <AdGroupBreadcrumbsComponent {...data} screenshotMode={extra?.screenshotMode} />
        ),
        width: 400,
    },
    Cost: { key: 'cost', title: 'Spend', formatter: money, width: 100 },
    ACOS: { key: 'acos', title: AcosHeader(), cell: AcosCell, formatter: percentage, width: 100 },
    ROAS: {
        key: 'roas',
        title: RoasHeader(),
        cell: RoasCell,
        formatter: (v) => number(v, 2),
        width: 100,
    },
    Sales: { key: 'sales', title: 'Sales', formatter: money, width: 100 },
    Clicks: { key: 'clicks', formatter: number, width: 100 },
    CPC: { key: 'cpc', title: CpcHeader(), cell: CpcCell, formatter: money, width: 100 },
    RPC: { key: 'rpc', title: RpcHeader(), cell: RpcCell, formatter: money, width: 100 },
    CTR: { key: 'ctr', title: CtrHeader(), cell: CtrCell, formatter: percentage, width: 100 },
    Impressions: { key: 'impressions', formatter: number, width: 100 },
    Orders: { key: 'orders', formatter: number, width: 100 },
    CVR: { key: 'cvr', title: CvrHeader(), cell: CvrCell, formatter: percentage, width: 100 },
    CAC: { key: 'cac', title: CacHeader(), cell: CacCell, formatter: money, width: 100 },
    AOV: { key: 'aov', title: AovHeader(), cell: AovCell, formatter: money, width: 100 },
    PagesRead: { key: 'pages_read', formatter: number },
    EstimatedRoyalties: { key: 'estimated_royalties', formatter: money },
    TargetCPC: { key: 'ideal_cpc', title: TargetCpcHeader(), formatter: money, width: 100 },

    TargetingType: { key: 'targeting_type', title: 'Targeting', cell: TargetingTypeBadge },
    KeywordMatchType: { key: 'match_type', title: 'Targeting', cell: KeywordMatchTypeBadge },
    DailyBudget: {
        key: 'daily_budget',
        title: 'Budget',
        width: 110,
        cell: (item, extra) => {
            if (extra?.recipe_version === 2) {
                return money(item.daily_budget ?? item.budget)
            }

            return cents(item.daily_budget ?? item.budget)
        },
    },
    DefaultBid: {
        key: 'default_bid',
        title: 'Bid',
        formatter: cents,
        cell: (item, { recipe_version }) => {
            if (recipe_version === 2) {
                return money(item.default_bid)
            }

            return cents(item.default_bid)
        },
    },
    Bid: {
        key: 'bid',
        title: 'Bid',
        formatter: cents,
        cell: (item, { recipe_version }) => {
            if (recipe_version === 2) {
                return money(item.bid)
            }

            return cents(item.bid)
        },
    },
    BidStrategy: {
        key: 'bid_strategy',
        title: 'Bid Strategy',
        cell: (item) => {
            if (item?.optimization?.bidStrategy) {
                const v = item?.optimization?.bidStrategy
                return v.replaceAll('_', ' ').toLowerCase()
            }

            return ''
        },
    },
    TargetingExpression: {
        key: 'targeting_expression',
        title: 'Target',
        cell: (target, { screenshotMode, mutateItems, props }) => {
            return (
                <RenderTargetName
                    {...{
                        data: target,
                        screenshotMode,
                        mutateItems,
                        ...props,
                    }}
                />
            )
        },
        width: 300,
    },
    ExpressionType: {
        key: 'expression_type',
        title: 'Targeting',
        cell: ({ expression_type }) => <TargetingTypeBadge targeting_type={expression_type} />,
    },
    Keyword: {
        key: 'keyword_text',
        title: 'Keyword',
        cell: (keyword, { screenshotMode, mutateItems, props }) => (
            <RenderKeywordName
                {...{
                    data: keyword,
                    screenshotMode,
                    mutateItems,
                    ...props,
                }}
            />
        ),
        width: 300,
    },
    KeywordOrTarget: {
        key: 'target_details',
        title: 'Target',
        cell: (target, { screenshotMode, mutateItems, props }) => (
            <RenderKeywordOrTargetName
                {...{
                    data: target,
                    screenshotMode,
                    mutateItems,
                    ...props,
                }}
            />
        ),
        width: 300,
    },
    Parent: {
        text_title: 'Campaign & Ad Group',
        title: (
            <div>
                <span>Campaign</span>
                <br />
                <span>Ad Group</span>
            </div>
        ),
        key: 'campaign_name',
        sortable: true,
        cell: (keywordOrTarget, { screenshotMode }) => {
            return (
                <KeywordAndTargetBreadcrumbs
                    className={cx({
                        blur: screenshotMode,
                    })}
                    ad_group_status={keywordOrTarget.parent_ad_group_status}
                    campaign_status={keywordOrTarget.parent_campaign_status}
                    {...keywordOrTarget}
                />
            )
        },
        width: 400,
    },
    TargetedProducts: {
        key: 'product_ads_count',
        sortable: true,
        title: 'Products',
        cell: (item, { screenshotMode }) => (
            <TargetedProducts
                className={cx({
                    blur: screenshotMode,
                })}
                item={item}
            />
        ),
    },
    TotalPromotionsNames: {
        key: 'total_promotions',
        sortable: true,
        title: 'Total Smart Campaigns',
        cell: (item, { screenshotMode }) => (
            <TotalPromotionsNames
                className={cx({
                    blur: screenshotMode,
                })}
                item={item}
            />
        ),
    },
    TotalActivePromotionsNames: {
        key: 'active_promotions',
        sortable: true,
        title: 'Active Smart Campaigns',
        cell: (item, { screenshotMode }) => (
            <TotalPromotionsNames
                className={cx({
                    blur: screenshotMode,
                })}
                item={item}
                onlyEnabled
            />
        ),
    },
    TargetACOS: {
        key: 'target_acos',
        cell: (product, { mutateItems, props }, disabled = false) => {
            return (
                <TargetACOS
                    disabled={disabled}
                    target={props.target}
                    product={p}
                    mutateItems={mutateItems}
                />
            )
        },
        width: 100,
    },
    StartDate: {
        key: 'start_date',
        title: 'Start Date',
        width: 100,
    },
    EndDate: {
        key: 'end_date',
        title: 'End Date',
        width: 100,
    },
    SmartBidToggle: {
        key: 'smart_bid',
        title: (
            <div>
                <Tooltip
                    hoverOpenDelay={300}
                    openOnTargetFocus={false}
                    content={
                        <div style={{ maxWidth: '400px' }}>
                            <p className="my-0">
                                Smart Bids+ automatically changes bids on a daily basis for
                                campaigns with Smart Bids+ enabled, using an algorithm that factors
                                in your target ACOS, conversion rates, and the maximum bid
                                adjustment.
                                <br />
                                <br />
                                This applies to targets or keywords that have two or more orders
                                within the specified lookback period.
                            </p>
                        </div>
                    }
                >
                    Smart Bids+
                </Tooltip>
            </div>
        ),
        sortable: true,
        cell: (campaign, extra, disabled = false) => (
            <SmartBidToggle disabled={disabled} campaign={campaign} extra={extra} />
        ),
        width: 90,
    },

    LastDailyBudgetChange: {
        key: 'last_daily_budget_change',
        cell: (item) => {
            const v = item.last_daily_budget_change ?? item.last_budget_change

            return v ? <RelativeTimestamp date={new Date(toMillisecondTimestmap(v))} /> : null
        },
    },
    LastDefaultBidChange: {
        key: 'last_default_bid_change',
        title: 'Last Bid Change',
        cell: (item) =>
            item.last_default_bid_change ? (
                <RelativeTimestamp
                    date={new Date(toMillisecondTimestmap(item.last_default_bid_change))}
                />
            ) : null,
    },
    LastBidChange: {
        key: 'last_bid_change',
        cell: (item) =>
            item.last_bid_change ? (
                <RelativeTimestamp date={new Date(toMillisecondTimestmap(item.last_bid_change))} />
            ) : null,
    },
    CreatedAt: {
        key: 'created_at',
        cell: (item) =>
            item.created_at ? <RelativeTimestamp date={new Date(item.created_at)} /> : null,
        sortable: true,
    },
    TopOfSearchImpressionShare: {
        key: 'top_of_search_impression_share',
        title: TosImpShareHeader(),
        cell: (item) =>
            item.top_of_search_impression_share
                ? percentage(item.top_of_search_impression_share / 100, 2)
                : '',
        width: 100,
    },
    IsNegated: {
        key: 'is_negated',
        title: 'Negated',
        width: 100,
        cell: (item) => {
            const status = item.is_negated ? 'true' : 'false'

            if (!item.is_negated) {
                return (
                    <Tooltip content="This search term is not negated.">
                        <span>{status}</span>
                    </Tooltip>
                )
            }

            // Build negation details for tooltip
            const negationDetails = []

            // Add campaign negatives
            if (item.campaign_negatives && item.campaign_negatives.length > 0) {
                item.campaign_negatives.forEach((negative) => {
                    if (negative.type === 'campaign_negative_keyword') {
                        const matchType =
                            negative.match_type === 1
                                ? 'Exact Match'
                                : negative.match_type === 2
                                  ? 'Phrase Match'
                                  : 'Broad Match'
                        negationDetails.push(`Campaign Negative ${matchType} Keyword`)
                    } else if (negative.type === 'campaign_negative_target') {
                        negationDetails.push('Campaign Negative Target')
                    }
                })
            }

            // Add ad group negatives
            if (item.ad_group_negatives && item.ad_group_negatives.length > 0) {
                item.ad_group_negatives.forEach((negative) => {
                    if (negative.type === 'ad_group_negative_keyword') {
                        const matchType =
                            negative.match_type === 1
                                ? 'Exact Match'
                                : negative.match_type === 2
                                  ? 'Phrase Match'
                                  : 'Broad Match'
                        negationDetails.push(`Ad Group Negative ${matchType} Keyword`)
                    } else if (negative.type === 'ad_group_negative_target') {
                        negationDetails.push('Ad Group Negative Target')
                    }
                })
            }

            // Add target negatives
            if (item.target_negatives && item.target_negatives.length > 0) {
                item.target_negatives.forEach((negative) => {
                    if (negative.type === 'ad_group_negative_target') {
                        negationDetails.push('Ad Group Negative Target')
                    } else if (negative.type === 'campaign_negative_target') {
                        negationDetails.push('Campaign Negative Target')
                    }
                })
            }

            const tooltipContent =
                negationDetails.length > 0
                    ? negationDetails.join('\n• ')
                    : 'This search term is negated.'

            return (
                <Tooltip
                    content={
                        <div style={{ whiteSpace: 'pre-line' }}>
                            {negationDetails.length > 0 && '• '}
                            {tooltipContent}
                        </div>
                    }
                >
                    <span>{status}</span>
                </Tooltip>
            )
        },
    },
}
